export default "__VITE_ASSET__Dtc1Okqu__"